import { ApiError, createApiClient } from '@kent/shared';

export { ApiError };

export const apiClient = createApiClient('kent-hr-auth', {
  onUnauthorized: () => {
    const stored = localStorage.getItem('kent-hr-auth');
    if (!stored) return;

    try {
      const parsed = JSON.parse(stored) as { state?: { isAuthenticated?: boolean } };
      if (parsed.state?.isAuthenticated) {
        localStorage.removeItem('kent-hr-auth');
        window.location.href = '/login';
      }
    } catch {
      // Ignore parse errors
    }
  },
});
